import React from "react";
import HealthScreenForm from "./App";

const NurseChatPage = () => {
  return <HealthScreenForm forcedService="nurse chat" />;
};

export default NurseChatPage;
